import { render, staticRenderFns } from "./groups_list.vue?vue&type=template&id=454fe97b&scoped=true&"
import script from "./groups_list.vue?vue&type=script&lang=js&"
export * from "./groups_list.vue?vue&type=script&lang=js&"
import style0 from "./groups_list.vue?vue&type=style&index=0&id=454fe97b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454fe97b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('454fe97b')) {
      api.createRecord('454fe97b', component.options)
    } else {
      api.reload('454fe97b', component.options)
    }
    module.hot.accept("./groups_list.vue?vue&type=template&id=454fe97b&scoped=true&", function () {
      api.rerender('454fe97b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/modifiers/groups/choose/list/groups_list.vue"
export default component.exports